export default __webpack_public_path__ + "static/media/screen-lorem-ipsum-flexbox-min.63155fcb.png";